// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mapadapter-ctrl-left,
.mapadapter-ctrl-right,
.mapadapter-ctrl-top-left,
.mapadapter-ctrl-top-right,
.mapadapter-ctrl-bottom-left,
.mapadapter-ctrl-bottom-right {
    position: absolute;
    z-index: 2;
    pointer-events: none;
}

.mapadapter-ctrl-left,
.mapadapter-ctrl-right {
    height: 100%;
}

.mapadapter-ctrl-left {
    padding-right: 0;
}

.mapadapter-ctrl-right {
    padding-left: 0;
}

.mapadapter-ctrl-top-left {
    top: 0;
    left: 0;
}

.mapadapter-ctrl-top-right {
    top: 0;
    right: 0;
}

.mapadapter-ctrl-bottom-left {
    bottom: 0;
    left: 0;
}

.mapadapter-ctrl-bottom-right {
    right: 0;
    bottom: 0;
}

.mapadapter-ctrl {
    clear: both;
    /* workaround for a Safari bug https://github.com/mapbox/mapbox-gl-js/issues/8185 */
    transform: translate(0, 0);
    pointer-events: auto;
}

.mapadapter-ctrl-top-left .mapadapter-ctrl {
    float: left;
    margin: 10px 0 0 10px;
}

.mapadapter-ctrl-top-right .mapadapter-ctrl {
    float: right;
    margin: 10px 10px 0 0;
}

.mapadapter-ctrl-bottom-left .mapadapter-ctrl {
    float: left;
    margin: 0 0 10px 10px;
}

.mapadapter-ctrl-bottom-right .mapadapter-ctrl {
    float: right;
    margin: 0 10px 10px 0;
}

.mapadapter-ctrl-group {
    border-radius: 2px;
    background: #fff;
}

.mapadapter-ctrl-group:not(:empty) {
    box-shadow: 0 3px 7px rgba(2, 34, 60, 0.16);
}

@media (-ms-high-contrast: active) {
    .mapadapter-ctrl-group:not(:empty) {
        box-shadow: 0 0 0 2px ButtonText;
    }
}

.mapadapter-ctrl-group button {
    display: block;
    cursor: pointer;
    box-sizing: border-box;
    outline: none;
    border: 0;
    background-color: transparent;
    padding: 0;
    width: 29px;
    height: 29px;
    fill: var(--primary);
    cursor: pointer;
    color: var(--primary);
}

.mapadapter-ctrl-group button + button {
    border-top: 1px solid #ddd;
}

.mapadapter-ctrl button .mapadapter-ctrl-icon {
    display: block;
    background-position: center center;
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
}

@media (-ms-high-contrast: active) {
    .mapadapter-ctrl-icon {
        background-color: transparent;
    }
    .mapadapter-ctrl-group button + button {
        border-top: 1px solid ButtonText;
    }
}

/* https://bugzilla.mozilla.org/show_bug.cgi?id=140562 */

.mapadapter-ctrl button::-moz-focus-inner {
    border: 0;
    padding: 0;
}

.mapadapter-ctrl-group button:focus {
    box-shadow: 0 3px 7px rgba(2, 34, 60, 0.16);
}

.mapadapter-ctrl button:disabled {
    cursor: not-allowed;
}

.mapadapter-ctrl button:disabled .mapadapter-ctrl-icon {
    opacity: 0.25;
}

.mapadapter-ctrl button:not(:disabled):hover {
    background-color: rgba(0, 0, 0, 0.05);
}

.mapadapter-ctrl-group button:focus:focus-visible {
    box-shadow: 0 3px 7px rgba(2, 34, 60, 0.16);
}

.mapadapter-ctrl-group button:focus:not(:focus-visible) {
    box-shadow: none;
}

.mapadapter-ctrl-group button:focus:first-child {
    border-radius: 4px 4px 0 0;
}

.mapadapter-ctrl-group button:focus:last-child {
    border-radius: 0 0 4px 4px;
}

.mapadapter-ctrl-group button:focus:only-child {
    border-radius: inherit;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/webmap/nodepkg/control-container/ControlContainer.css"],"names":[],"mappings":"AAAA;;;;;;IAMI,kBAAkB;IAClB,UAAU;IACV,oBAAoB;AACxB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,MAAM;IACN,OAAO;AACX;;AAEA;IACI,MAAM;IACN,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,OAAO;AACX;;AAEA;IACI,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,WAAW;IACX,mFAAmF;IACnF,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI;QACI,gCAAgC;IACpC;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,aAAa;IACb,SAAS;IACT,6BAA6B;IAC7B,UAAU;IACV,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,kCAAkC;IAClC,4BAA4B;IAC5B,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,6BAA6B;IACjC;IACA;QACI,gCAAgC;IACpC;AACJ;;AAEA,wDAAwD;;AAExD;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":[".mapadapter-ctrl-left,\n.mapadapter-ctrl-right,\n.mapadapter-ctrl-top-left,\n.mapadapter-ctrl-top-right,\n.mapadapter-ctrl-bottom-left,\n.mapadapter-ctrl-bottom-right {\n    position: absolute;\n    z-index: 2;\n    pointer-events: none;\n}\n\n.mapadapter-ctrl-left,\n.mapadapter-ctrl-right {\n    height: 100%;\n}\n\n.mapadapter-ctrl-left {\n    padding-right: 0;\n}\n\n.mapadapter-ctrl-right {\n    padding-left: 0;\n}\n\n.mapadapter-ctrl-top-left {\n    top: 0;\n    left: 0;\n}\n\n.mapadapter-ctrl-top-right {\n    top: 0;\n    right: 0;\n}\n\n.mapadapter-ctrl-bottom-left {\n    bottom: 0;\n    left: 0;\n}\n\n.mapadapter-ctrl-bottom-right {\n    right: 0;\n    bottom: 0;\n}\n\n.mapadapter-ctrl {\n    clear: both;\n    /* workaround for a Safari bug https://github.com/mapbox/mapbox-gl-js/issues/8185 */\n    transform: translate(0, 0);\n    pointer-events: auto;\n}\n\n.mapadapter-ctrl-top-left .mapadapter-ctrl {\n    float: left;\n    margin: 10px 0 0 10px;\n}\n\n.mapadapter-ctrl-top-right .mapadapter-ctrl {\n    float: right;\n    margin: 10px 10px 0 0;\n}\n\n.mapadapter-ctrl-bottom-left .mapadapter-ctrl {\n    float: left;\n    margin: 0 0 10px 10px;\n}\n\n.mapadapter-ctrl-bottom-right .mapadapter-ctrl {\n    float: right;\n    margin: 0 10px 10px 0;\n}\n\n.mapadapter-ctrl-group {\n    border-radius: 2px;\n    background: #fff;\n}\n\n.mapadapter-ctrl-group:not(:empty) {\n    box-shadow: 0 3px 7px rgba(2, 34, 60, 0.16);\n}\n\n@media (-ms-high-contrast: active) {\n    .mapadapter-ctrl-group:not(:empty) {\n        box-shadow: 0 0 0 2px ButtonText;\n    }\n}\n\n.mapadapter-ctrl-group button {\n    display: block;\n    cursor: pointer;\n    box-sizing: border-box;\n    outline: none;\n    border: 0;\n    background-color: transparent;\n    padding: 0;\n    width: 29px;\n    height: 29px;\n    fill: var(--primary);\n    cursor: pointer;\n    color: var(--primary);\n}\n\n.mapadapter-ctrl-group button + button {\n    border-top: 1px solid #ddd;\n}\n\n.mapadapter-ctrl button .mapadapter-ctrl-icon {\n    display: block;\n    background-position: center center;\n    background-repeat: no-repeat;\n    width: 100%;\n    height: 100%;\n}\n\n@media (-ms-high-contrast: active) {\n    .mapadapter-ctrl-icon {\n        background-color: transparent;\n    }\n    .mapadapter-ctrl-group button + button {\n        border-top: 1px solid ButtonText;\n    }\n}\n\n/* https://bugzilla.mozilla.org/show_bug.cgi?id=140562 */\n\n.mapadapter-ctrl button::-moz-focus-inner {\n    border: 0;\n    padding: 0;\n}\n\n.mapadapter-ctrl-group button:focus {\n    box-shadow: 0 3px 7px rgba(2, 34, 60, 0.16);\n}\n\n.mapadapter-ctrl button:disabled {\n    cursor: not-allowed;\n}\n\n.mapadapter-ctrl button:disabled .mapadapter-ctrl-icon {\n    opacity: 0.25;\n}\n\n.mapadapter-ctrl button:not(:disabled):hover {\n    background-color: rgba(0, 0, 0, 0.05);\n}\n\n.mapadapter-ctrl-group button:focus:focus-visible {\n    box-shadow: 0 3px 7px rgba(2, 34, 60, 0.16);\n}\n\n.mapadapter-ctrl-group button:focus:not(:focus-visible) {\n    box-shadow: none;\n}\n\n.mapadapter-ctrl-group button:focus:first-child {\n    border-radius: 4px 4px 0 0;\n}\n\n.mapadapter-ctrl-group button:focus:last-child {\n    border-radius: 0 0 4px 4px;\n}\n\n.mapadapter-ctrl-group button:focus:only-child {\n    border-radius: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
